import React, { useState, useEffect } from 'react';
import Loader from '../Common/Loader';
import { getFormattedNumber } from '../utils/textUtils';
import { wipReport } from '../../services/Purchase/Reports';

const WipReport = ({ resPacket, loading }) => {
    const [show, setShow] = useState(false);
    const [itemList, setItemList] = useState([]);
    const [selectedItem, setSelectedItem] = useState({});

    useEffect(() => {
        if (!show) {
            setItemList([]);
            setSelectedItem({});
        }   
    }, [show]);

    const getWipReportsByItemID = () => {
        // setSelectedItem(item);
        wipReport().then((res) => {
            if(res.responsePacket){
                setItemList(res.responsePacket);
                setShow(true);
            }
        });
    };


    if (loading) {
        return <Loader />;
    }

    if (resPacket?.length === 0) {
        return "No Records Found";
    }

    return (
        <div className="customTable"  id="scroll"> 
        <table className="customTable w-100">
            <thead className="fixed-thead">
                <tr>
                    <td>SNO.</td>
                    {/* <td>BATCH NO.</td> */}
                    <td>TITLE</td>
                    <td>PACK QUANTITY</td>
                    <td>OPEN QUANTITY</td>
                    <td>DEPARTMENT TITLE</td>
                    <td className='text-center'>WAREHOUSE</td>
                    <td>ORGANISATION TITLE</td>
                    {/* <td>PURCHASE PRICE</td>
                    <td>ALT QTY</td> */}
                    {/* <td className='text-center'>ITEM RATE</td>
                    <td className='text-center'>AMOUNT</td>
                    <td className='text-center'>TAX RATE</td>
                    <td className='text-center'>TOTAL AMOUNT</td> */}
                </tr>
            </thead>
            <tbody className="body-scroll-custom">
                {resPacket&&resPacket?.map((row, i) => (
                    <tr key={i} onClick={() => getWipReportsByItemID(row)} style={{ cursor: "pointer" }}>
                        <td>{i+1}</td>
                        {/* <td>{row.batchNumber }</td> */}
                        <td>{row.itemTitle }</td>
                        <td>{row.packQuantity }</td>
                        <td>{row.openQuantity}</td>
                        <td>{row.departmentTitle}</td>    
                        <td>{row.warehouseTitle}</td>  
                        {/* <td className='text-right'>{getFormattedNumber(row.qty)}</td> */}
                        <td>{row.organisationTitle}</td>
                        {/* <td>{getFormattedNumber(row.itemPurchasePrice)}</td>
                        <td>{row.altQty}</td> */}
                        {/* <td className='text-right'>{getFormattedNumber(row.rate)}</td>
                        <td className='text-right'>{getFormattedNumber(row.amount)}</td>
                        <td className='text-right'>{getNumber(row.taxRate)}</td>
                        <td className='text-right'>{getTotalAmount(row)}</td> */}
                    </tr>
                ))}
            </tbody>
        </table>
        </div>
    );
};

export default WipReport;
